// src/components/Navigation.jsx
import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Facebook, Instagram, LinkedIn } from "@mui/icons-material";
import Momentsia_logo from "../images/Momentsia _logo.png";

const T1 = "#0ecfb0";
const T2 = "#0aa896";
const T3 = "#077a6e";
const NAVY = "#0d1b2a";
const TEAL_GRAD = `linear-gradient(135deg, ${T1}, ${T3})`;

// Logo Component
const MomentsiaLogo = ({ light = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
    <img src={Momentsia_logo} alt="Momentsia" style={{ height: 48, width: "auto", objectFit: "contain" }} />
  </div>
);

// Navigation Items
const navItems = [
  { label: "About Us", path: "/about" },
  { label: "Talent", path: "/talent-management" },
  { label: "Event Gallery", path: "/event-photo-gallery" },
  { label: "Contact", path: "/contact" },
];

const Navigation = ({ onPlanEventClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* TOP BAR */}
      <div style={{ 
        background: NAVY, 
        padding: "9px 24px", 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        flexWrap: "wrap", 
        gap: 8 
      }}>
        <a href="tel:+918100364941" style={{ 
          color: "#7ecbc4", 
          fontSize: 13, 
          display: "flex", 
          alignItems: "center", 
          gap: 7, 
          textDecoration: "none" 
        }}>
          <span>📞</span> +91 81003 64941
        </a>
        
        <div style={{ display: "flex", gap: 8 }}>
          <IconButton
            component="a"
            href="https://www.facebook.com/share/16jRnLsBU4/"
            target="_blank"
            size="small"
            sx={{
              bgcolor: "#3b5998",
              color: "white",
              "&:hover": { bgcolor: "#2d4373" },
            }}
          >
            <Facebook fontSize="small" />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.instagram.com/momentsia_events?igsh=cjc4YXA2aDQ2cWQ3"
            target="_blank"
            size="small"
            sx={{
              bgcolor: "#E4405F",
              color: "white",
              "&:hover": { bgcolor: "#c13584" },
            }}
          >
            <Instagram fontSize="small" />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.linkedin.com/company/momentsiaevents/"
            target="_blank"
            size="small"
            sx={{
              bgcolor: "#0077b5",
              color: "white",
              "&:hover": { bgcolor: "#005582" },
            }}
          >
            <LinkedIn fontSize="small" />
          </IconButton>
        </div>
      </div>

      {/* NAVIGATION */}
      <nav style={{ 
        background: "#fff", 
        boxShadow: scrolled 
          ? "0 4px 24px rgba(14,207,176,0.13),0 2px 8px rgba(0,0,0,0.08)" 
          : "0 2px 8px rgba(0,0,0,0.07)", 
        position: "sticky", 
        top: 0, 
        zIndex: 1000, 
        borderBottom: scrolled ? `2.5px solid ${T1}` : "2.5px solid transparent", 
        transition: "border-color .3s,box-shadow .3s" 
      }}>
        <div style={{ 
          maxWidth: 1200, 
          margin: "0 auto", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between", 
          padding: "0 24px" 
        }}>
          <a href="/" style={{ textDecoration: "none", padding: "10px 0", display: "block" }}>
            <MomentsiaLogo />
          </a>
          
          {/* Desktop Navigation */}
          <ul className="dnav" style={{ 
            display: "flex", 
            alignItems: "center", 
            listStyle: "none", 
            margin: 0, 
            padding: 0, 
            gap: 0 
          }}>
            <li>
              <a href="/" className="nav-lnk" style={{ 
                color: "#333", 
                fontWeight: 600, 
                fontSize: 14, 
                padding: "20px 14px", 
                display: "block", 
                textDecoration: "none", 
                whiteSpace: "nowrap" 
              }}>
                Home
              </a>
            </li>
            {navItems.map(item => (
              <li key={item.label}>
                <a href={item.path} className="nav-lnk" style={{ 
                  color: "#333", 
                  fontWeight: 600, 
                  fontSize: 14, 
                  padding: "20px 14px", 
                  display: "block", 
                  textDecoration: "none", 
                  whiteSpace: "nowrap" 
                }}>
                  {item.label}
                </a>
              </li>
            ))}
            <li style={{ listStyle: "none", marginLeft: 12 }}>
              <button 
                className="cb" 
                onClick={onPlanEventClick} 
                style={{ 
                  background: TEAL_GRAD, 
                  color: "#fff", 
                  border: "none", 
                  borderRadius: 6, 
                  padding: "10px 22px", 
                  fontWeight: 700, 
                  fontSize: 13, 
                  cursor: "pointer", 
                  whiteSpace: "nowrap", 
                  boxShadow: `0 4px 14px rgba(14,207,176,0.35)` 
                }}
              >
                Plan Your Event
              </button>
            </li>
          </ul>

          {/* Mobile Menu Toggle */}
          <button 
            className="mtog" 
            onClick={() => setMobileOpen(!mobileOpen)} 
            style={{ 
              display: "none", 
              flexDirection: "column", 
              gap: 5, 
              background: "none", 
              border: "none", 
              cursor: "pointer", 
              padding: 8 
            }}
          >
            {[0, 1, 2].map(i => (
              <span key={i} style={{ 
                display: "block", 
                width: 24, 
                height: 2.5, 
                background: T2, 
                borderRadius: 2 
              }} />
            ))}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileOpen && (
          <div className="mmenu" style={{ 
            background: "#fff", 
            borderTop: `2px solid ${T1}` 
          }}>
            <a href="/" style={{ 
              display: "block", 
              padding: "13px 24px", 
              color: "#333", 
              fontWeight: 600, 
              fontSize: 14, 
              textDecoration: "none", 
              borderBottom: "1px solid #f0f0f0" 
            }} onClick={() => setMobileOpen(false)}>
              Home
            </a>
            {navItems.map(item => (
              <a key={item.label} 
                href={item.path} 
                style={{ 
                  display: "block", 
                  padding: "13px 24px", 
                  color: "#333", 
                  fontWeight: 600, 
                  fontSize: 14, 
                  textDecoration: "none", 
                  borderBottom: "1px solid #f0f0f0" 
                }} 
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <div style={{ padding: "14px 24px" }}>
              <button 
                onClick={() => { 
                  onPlanEventClick(); 
                  setMobileOpen(false); 
                }} 
                style={{ 
                  width: "100%", 
                  padding: "12px", 
                  background: TEAL_GRAD, 
                  color: "#fff", 
                  border: "none", 
                  borderRadius: 6, 
                  fontWeight: 700, 
                  fontSize: 14, 
                  cursor: "pointer" 
                }}
              >
                Free Consultation
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Styles */}
      <style>{`
        .nav-lnk:hover {
          color: ${T1} !important;
        }
        .cb:hover {
          opacity: 0.88;
          transform: translateY(-1px);
        }
        @media (max-width: 900px) {
          .dnav {
            display: none !important;
          }
          .mtog {
            display: flex !important;
          }
        }
        @media (min-width: 901px) {
          .mmenu {
            display: none !important;
          }
          .mtog {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default Navigation;